export default __webpack_public_path__ + "static/media/logo.f43a2245.svg";